import { ArrowUpRight, Send, Twitter } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Community() {
  return (
    <section id="community" data-testid="community-section" className="relative py-28 sm:py-36">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 left-1/2 h-[50vh] w-[70vw] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgba(57,255,20,0.08),transparent)]"
      />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading index="05" eyebrow="COMMUNITY" title="JOIN THE CHEEK SQUAD" testId="community-heading" />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-[#9fb39f] sm:text-base">
            The timeline is watching. Say gm, bring memes, and never look away
            when he turns around.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3">
          <Reveal className="md:col-span-2">
            <a
              data-testid="community-x-link"
              href="https://x.com/PEPEBUTTCOIN"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex h-full flex-col justify-between border border-neon/50 bg-surface p-8 transition-colors duration-300 hover:bg-neon sm:p-10"
            >
              <div className="flex items-center justify-between">
                <Twitter size={22} className="text-neon transition-colors duration-300 group-hover:text-nox" />
                <ArrowUpRight
                  size={22}
                  className="text-neon transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-nox"
                />
              </div>
              <div className="mt-16">
                <p className="font-display text-2xl font-extrabold tracking-tight text-[#EDEDE4] uppercase transition-colors duration-300 group-hover:text-nox sm:text-3xl">
                  @PEPEBUTTCOIN
                </p>
                <p className="mt-2 font-mono text-xs tracking-[0.2em] text-[#6b7f6b] uppercase transition-colors duration-300 group-hover:text-nox/70">
                  Follow the cheeks on X — launch alerts drop here first
                </p>
              </div>
            </a>
          </Reveal>

          <div className="flex flex-col gap-4">
            <Reveal delay={0.1} className="flex-1">
              <a
                data-testid="community-telegram-link"
                href="https://t.me/PEPEBUTTGROUP"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex h-full flex-col justify-between border border-line bg-nox p-8 transition-colors duration-300 hover:border-neon/60"
              >
                <div className="flex items-center justify-between">
                  <Send size={20} className="text-neon" />
                  <ArrowUpRight
                    size={18}
                    className="text-[#6b7f6b] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-neon"
                  />
                </div>
                <div className="mt-10">
                  <p className="font-display text-lg font-extrabold tracking-tight text-[#EDEDE4] uppercase">
                    TELEGRAM
                  </p>
                  <p className="mt-2 font-vt text-xl text-neon">
                    t.me/PEPEBUTTGROUP
                  </p>
                </div>
              </a>
            </Reveal>
            <Reveal delay={0.2} className="flex-1">
              <div
                data-testid="community-chart-card"
                className="flex h-full flex-col justify-between border border-line bg-nox p-8"
              >
                <span className="font-vt text-2xl text-[#6b7f6b]">{"[/]"}</span>
                <div className="mt-10">
                  <p className="font-display text-lg font-extrabold tracking-tight text-[#9fb39f] uppercase">
                    DEXSCREENER
                  </p>
                  <p className="mt-2 font-vt text-xl text-punk">LIVE AT LAUNCH</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
